/* eslint-disable lines-between-class-members,dot-notation */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Product, ProductBase, ProductOption } from "../Products";
import { Company } from "./Company";
import { updatedType, updatedTypeTitle } from "./enums";
/**
 * Company offer model
 */

export class Offer extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return Number(this.model.id);
    };

    this.getCompanyId = () => {
      return Number(this.model.companyId);
    };

    this.getProductId = () => {
      return Number(this.model.productId);
    };

    this.getPrice = () => {
      return Number(this.model.price);
    };

    this.getPurchasePrice = () => {
      return Number(this.model.purchasePrice);
    };

    this.isAvailable = () => {
      return Boolean(this.model.isAvailable);
    };

    this.getRestCount = () => {
      return Number(this.model.restCount);
    };

    this.getHoldCount = () => {
      return Number(this.model.holdCount);
    };

    this.getUpdatedType = (asLabel = false) => {
      return asLabel ? Offer.updatedTypeTitles[this.model.updatedType || 'unknown'] || Offer.updatedTypeTitles['unknown'] : this.model.updatedType;
    };

    this.isWeight = () => {
      return this.model.isWeight;
    };

    this.getWeightBalance = () => {
      return this.model.weightBalance;
    };

    this.getPricePrefix = () => {
      return this.model.pricePrefix;
    };

    this.getPricePostfix = () => {
      return this.model.pricePostfix;
    };

    this.getSellingType = (asLabel = false) => {
      return asLabel ? Company.companiesSellingTypes[this.model.sellingType || 'unknown'] || Company.companiesSellingTypes['unknown'] : this.model.sellingType;
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getUpdatedAt = () => {
      return this.model.updatedAt;
    };

    this.getCompany = company => {
      return this.getRelation('company', Company, company);
    };

    this.getProduct = product => {
      return this.getRelation('product', Product, product);
    };

    this.getProductsBase = productsBase => {
      return this.getRelation('productsBase', ProductBase, productsBase, true);
    };

    this.getOption = option => {
      return this.getRelation('option', ProductOption, option);
    };
  }

  /**
   * Create company offer
   *
   * @param {object} object
   *
   * @return {Offer}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list company offers
   *
   * @param {object} objects
   *
   * @return {Array.<Offer>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map company offers
   *
   * @param {Array.<object>} objects
   * @param {function(Offer): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get offer id
   *
   * @return {number}
   */


}
Offer.updatedType = updatedType;
Offer.updatedTypeTitles = updatedTypeTitle;